module.exports = __webpack_public_path__ + "static/media/reverse-left.36c9a50a.svg";